import cx from 'classnames'
import Styles from './CreditUsage.module.scss'

import { Text } from 'blaze-ui/Text/Text'
import { Credits } from 'blaze-ui/icons/20/Credits'
import { useCreditUsage } from 'hooks/useCreditUsage'
import dayjs from 'dayjs'
import { useRootStore } from 'stores/RootStore'
import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { findPlanCreditLimit } from 'components/Settings/Workspace/AutopilotPlans/utils'

export const CreditUsage = ({ className }: { className: string }) => {
  const { creditsRemaining, endDate, baseCreditsAvailable, creditsExpiringSoon } = useCreditUsage()
  const {
    tierUsageStore: { currentSubscription, autopilotPlans },
  } = useRootStore()
  const refillDate = dayjs(endDate).add(1, 'day')
  const showCreditRefill = baseCreditsAvailable > 0 && currentSubscription?.status === 'active' && !creditsExpiringSoon
  const negativeCredits = creditsRemaining < 0
  const isTrialing = currentSubscription?.status === 'trialing' || currentSubscription?.status === 'canceled'
  const showUpgradeForCredits = isTrialing && creditsRemaining <= 0

  const planKey =
    currentSubscription?.plan === PaymentPlanKey.BlazeAutopilotGrowth
      ? PaymentPlanKey.BlazeAutopilotGrowth
      : PaymentPlanKey.BlazeAutopilotStarter
  const upgradeCredits = findPlanCreditLimit(autopilotPlans, planKey)

  return (
    <div className={cx(className, Styles.container)}>
      <div className={cx(Styles.creditUsageContainer, { [Styles.negativeCredits]: negativeCredits })}>
        <div className={Styles.top}>
          <Credits color={negativeCredits ? 'var(--red-50)' : 'var(--purple-50)'} />
          <Text variant="secondary">{creditsRemaining} credits</Text>
        </div>
        <div className={Styles.bottom}>
          {creditsExpiringSoon > 0 && (
            <Text variant="metadata" color="var(--dark-40)">
              {creditsExpiringSoon} credits expiring in 7 days
            </Text>
          )}
          {showCreditRefill && (
            <Text variant="metadata" color="var(--dark-40)">
              +{baseCreditsAvailable} monthly on {refillDate.format('MMM D')}
            </Text>
          )}
          {showUpgradeForCredits && (
            <Text variant="metadata" color="var(--upgrade)">
              Upgrade for {upgradeCredits} monthly credits
            </Text>
          )}
        </div>
      </div>
    </div>
  )
}
